var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.3335C4.32367 1.3335 1.33301 4.32416 1.33301 8.00016V10.7622C1.33301 11.4448 1.93101 12.0002 2.66634 12.0002H3.33301C3.50982 12.0002 3.67939 11.9299 3.80441 11.8049C3.92944 11.6799 3.99967 11.5103 3.99967 11.3335V7.90483C3.99967 7.72802 3.92944 7.55845 3.80441 7.43342C3.67939 7.3084 3.50982 7.23816 3.33301 7.23816H2.72767C3.09834 4.65816 5.31834 2.66683 7.99967 2.66683C10.681 2.66683 12.901 4.65816 13.2717 7.23816H12.6663C12.4895 7.23816 12.32 7.3084 12.1949 7.43342C12.0699 7.55845 11.9997 7.72802 11.9997 7.90483V12.0002C11.9997 12.7355 11.4017 13.3335 10.6663 13.3335H9.33301V12.6668H6.66634V14.6668H10.6663C12.137 14.6668 13.333 13.4708 13.333 12.0002C14.0683 12.0002 14.6663 11.4448 14.6663 10.7622V8.00016C14.6663 4.32416 11.6757 1.3335 7.99967 1.3335Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.98f36531d8c497d3261c6869c383864f.svg";
export { ForwardRef as ReactComponent };